var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArrowDatepicker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#383838"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.794 13.762l5.578-5.812c.633-.66 1.68-.68 2.338-.048l.049.048.072.075c.626.653.626 1.684 0 2.337l-4.39 4.572 4.39 4.574c.59.614.624 1.564.104 2.218l-.104.119-.072.075-.049.048c-.659.632-1.705.61-2.338-.048l-5.578-5.812c-.294-.308-.45-.699-.468-1.095v-.157c.018-.396.174-.787.468-1.094z",
    transform: "translate(-368.000000, -376.000000) translate(324.000000, 176.000000) translate(39.000000, 200.000000) translate(5.000000, -0.000000)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrowDatepicker);
export default __webpack_public_path__ + "static/media/left-arrow-datepicker.24fc76d342fdaf23e864e12b17ebd091.svg";
export { ForwardRef as ReactComponent };